import React from 'react';

import { Flex, FlexProps } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { ChatAttachmentConfigurationAccordion } from 'components/SmartAssistantSections/AdvancedSection/AdvancedAccordions/ChatAttachmentConfigurationAccordion';
import { ChatAttachmentConfigurationFormValues } from 'shared/interfaces/SmartAssistant';

interface AdvancedSectionProps extends FlexProps {
  chatAttachmentConfigurationForm?: UseFormReturnType<ChatAttachmentConfigurationFormValues> | undefined;
}

export function AdvancedSection({ chatAttachmentConfigurationForm, ...flexProps }: AdvancedSectionProps) {
  return (
    <Flex direction="column" gap="md" {...flexProps}>
      {chatAttachmentConfigurationForm && (
        <ChatAttachmentConfigurationAccordion chatAttachmentConfigurationForm={chatAttachmentConfigurationForm} />
      )}
    </Flex>
  );
}
